import React, { createContext, useState, useEffect, useContext } from 'react';

// Create PageContext
const PageContext = createContext();

// PageProvider Component
export const PageProvider = ({ children }) => {
  const [page, setPage] = useState(null);

  // Load session from sessionStorage when app starts
  useEffect(() => {
    const storedPage = sessionStorage.getItem('page');
    if (storedPage) {
      setPage(JSON.parse(storedPage));
    }
  }, []);

  // Login function to save session data
  const currentPage = (pageData) => {
    setPage(pageData);
    sessionStorage.setItem('page', JSON.stringify(pageData));
  };
  return (
    <PageContext.Provider value={{ page, currentPage }}>
      {children}
    </PageContext.Provider>
  );
};
export const usePage = () => useContext(PageContext);
